export abstract class EnvironmentService<T> {
   abstract environment: T;
}
